import React, { useState } from "react";
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { LARAVEL_APP_HOST, STORAGE } from "../../constants";
import {
  ConsumerApp,
  enumToArrayString,
} from "@theatticusapp/atticus-shared-components";
import { HelpDialog } from "../shared/HelpDialog";
import HelpIcon from "@mui/icons-material/Help";

const environments = enumToArrayString(ConsumerApp);
const HelpContent = (
  <Typography>
    The intention of this dev only feature is to enable a single preprod amplify
    hosted environment to connect to laravel preprod1 or preprod2. Remember not
    all environments can connect to each other. Laravel CORS settings will
    restrict these connections. Localhost can not connect to prod.
    <br />
    <br />
    <strong>Accounts are environment specific</strong>
    <br />
    Don't expect production accounts to exist in preprod or localhost.
  </Typography>
);

export const EnvironmentInputs = (): JSX.Element => {
  const [environment, setEnv] = useState(
    window.localStorage.getItem(STORAGE.envOverride) || LARAVEL_APP_HOST
  );
  const [showOverrideHelp, setShowOverrideHelp] = useState(false);

  return (
    <Box
      sx={{
        flexDirection: "column",
        textAlign: "center",
        backgroundColor: "white",
        width: {
          xs: "100%",
          sm: "80%",
        },
        m: 2,
      }}
    >
      <HelpDialog
        open={showOverrideHelp}
        title="LARAVEL HOST OVERRIDE"
        content={HelpContent}
        confirmText="Ok"
        onConfirm={() => setShowOverrideHelp(false)}
      />
      <Typography>
        <strong>LARAVEL HOST OVERRIDE</strong>
        <IconButton onClick={() => setShowOverrideHelp(true)}>
          <HelpIcon color="secondary" />
        </IconButton>
      </Typography>
      <FormControl
        sx={{
          my: 1,
        }}
      >
        <Select
          id="environment-select"
          name="environment"
          onChange={(event) => {
            const envHost = event.target.value;
            setEnv(envHost);
            if (envHost === "CLEAR") {
              window.localStorage.removeItem(STORAGE.envOverride);
            } else {
              window.localStorage.setItem(STORAGE.envOverride, envHost);
            }
            window.location.reload();
          }}
          value={environment}
          fullWidth
        >
          {environments.map((env: string) => {
            return (
              <MenuItem value={env} key={env}>
                {env}
              </MenuItem>
            );
          })}
          <MenuItem value="CLEAR" key="CLEAR">
            CLEAR OVERRIDE
          </MenuItem>
        </Select>
      </FormControl>
      {window.localStorage.getItem(STORAGE.envOverride) && (
        <Typography>
          <strong>CURRENT:</strong>{" "}
          {window.localStorage.getItem(STORAGE.envOverride)}
        </Typography>
      )}
    </Box>
  );
};
